import { dateFormatter, FORMAT_DATE } from './utils/dateFormatter';

export const formatDate = (date, format = FORMAT_DATE) => {
  return dateFormatter(date, format);
};

export const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};
